export default "__VITE_ASSET__BwBjU_o9__"